import { getBaseUrl } from '../utils/getBaseUrl';

const baseURL = getBaseUrl() + 'iquestion/';
const baselookupURL = getBaseUrl() + 'lookup/';

export const DeleteQuestion = async (questionId) => {
    try {
        await fetch(baseURL + 'delete', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: questionId
        });
        return "Deleted question";
    } catch (error) {
        console.error('Error deleting the question:', error);
    }
};

export const GetAllQuestions = async (subjectpk, level, iscode,pageNumber = 1, pageSize = 50) => {
    try {
            const response = await fetch(`${baseURL}getall?level=${level}&subjectpk=${subjectpk}&iscode=${iscode}&pageNumber=${pageNumber}&pageSize=${pageSize}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        
        const jsonData = await response.json();
        return jsonData;  // { question: [...], totalCount: N }
    } catch (error) {
        console.error('Error fetching all questions:', error);
    }
};

export const GetQuestionById = async (questionId) => {
    try {
        const response = await fetch(baseURL + `getbyid?pk=${questionId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error(`Error fetching question by ID (${questionId}):`, error);
    }
};

export const AddQuestion = async (questionBody) => {
    try {
        await fetch(baseURL + 'add', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: questionBody
        });
        return "Question added";
    } catch (error) {
        console.error('Error adding question:', error);
    }
};

export const GetAllLevels = async () => {
    try {
        const response = await fetch(baselookupURL + 'getall?name=questionlevel', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching all questions:', error);
    }
};
